import { useEffect, useState } from "react";
import { Box, Chip } from "@material-ui/core";
import _ from "lodash";
import { useOktaAuth } from "@okta/okta-react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getUsers, sortFilterMatrixAdmins } from "../../actions";

import List from "../../components/Common/List";
import * as Columns from "../../components/Common/DataTableColData";
import AdminUsersTableData from "../../components/Super/Admins/AdminUsersTableData";

const Admins = () => {
    let history = useHistory();
    const { oktaAuth, authState } = useOktaAuth();
    const token = oktaAuth.getAccessToken();
    const dispatch = useDispatch();
    const currentAdmin = useSelector((state) => state.user.usable);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const pagetitle = "Admins";
    const localstoragekey = "matrixadminslistview";
    const listitems = useSelector((state) => state.admins.usablelist);
    const [listData, setListData] = useState(false);
    const defaultViewColumns = Columns.adminsDefaultColumns;
    const availableColumns = Columns.adminsAvailableColumns;
    const [headerRow, setHeaderRow] = useState(
        <div className='table-header' style={{ fontSize: "1.2rem" }}>
            {pagetitle}
        </div>
    );
    const [footerRow, setFooterRow] = useState("");
    const [filter, setfilter] = useState({});
    const resetList = () => {
        if (filter) {
            dispatch(sortFilterMatrixAdmins({ filters: filter }));
        } else {
            dispatch(getUsers(token));
        }
    };
    const filterSortList = (filterObj) => {
        dispatch(sortFilterMatrixAdmins(filterObj));
    };
    const parselistitems = (items) => {
        let _filtereditems;
        if (items && currentAdmin && _.includes(["super"], currentAdmin.profile.matrixAdminRole)) {
            _filtereditems = _.compact(
                _.map(items, (user, i) => {
                    if (!user.profile.matrixTestAccount) {
                        return user;
                    }
                })
            );
        } else {
            _filtereditems = items;
        }
        return _filtereditems;
    };
    useEffect(() => {
        // customize per list
        if (selectedRow) {
            console.log(selectedRow);

            history.push(`/users/${selectedRow.id}`);
        }
    }, [selectedRow]);
    useEffect(() => {
        if (selectedColumns && selectedColumns.length >= 1) {
            setHeaderRow(
                <Box flexGrow={1}>
                    <span style={{ fontSize: "1.2rem" }}>{pagetitle}</span>
                </Box>
            );
        }
    }, [selectedColumns]);
    useEffect(() => {
        if (!_.isEmpty(currentAdmin)) {
            setfilter({});
        }
    }, [currentAdmin]);
    useEffect(() => {
        if (!_.isEmpty(listitems)) {
            let _data = _.compact(
                _.map(listitems, (user, i) => {
                    if (user.profile.matrixAdmin) {
                        return user;
                    }
                })
            );
            setListData(_data);
        }
    }, [listitems]);
    return (
        // <List
        //     pagetitle={pagetitle}
        //     localstoragekey={localstoragekey}
        //     listitems={listitems}
        //     selectedRow={selectedRow}
        //     setSelectedRow={setSelectedRow}
        //     selectedColumns={selectedColumns}
        //     setSelectedColumns={setSelectedColumns}
        //     defaultColumns={availableColumns}
        //     defaultView={defaultViewColumns}
        //     listfilter={filter}
        //     headerRow={headerRow}
        //     footerRow={footerRow}
        //     resetList={resetList}
        //     filterSortList={filterSortList}
        //     parselistitems={parselistitems}
        //     canExport={true}
        //     excelFileName={"matrixusers"}
        // />
        <AdminUsersTableData pagetitle={pagetitle} localstoragekey={localstoragekey} listitems={listData} />
    );
};

export default Admins;
